const HowTo = () => {
    return (
        <section className="howTo largePaper">
            <div className="largePaperText">
                <h2>How To</h2>
                    <p>
                        Let's create a haiku!
                    </p>
                    <p>
                        Haiku is a type of short form poetry originally from Japan. Traditional Japanese haiku consists of three phrases that contain 17 (phonetic units similar to syllables) in a 5, 7, 5 pattern.
                    </p>
                    <p>
                        Type your first word in the text box to get started. Once you have submitted your first word, we will give you a list of words to choose from to create the rest of your haiku. Each word returned will have an association to the previous word.
                    </p>
                    <p>
                        Go ahead and try out and create your beautiful haiku!
                    </p>
                    <p>
                        Remember each line must have the correct amount of syllables following the pattern of 5, 7, 5.
                    </p>
            </div>
        </section>
    )
}

export default HowTo;

